<template>
  <v-main class="primary mt-4">
    <router-view />
  </v-main>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'IndexView',

  async mounted() {
    this.fetchSolicitudes();
    this.fetchProgramacionesEvaluaciones();
    this.fetchExpedientes();
    this.fetchEstatusProgramacion();
    this.fetchTipoSolicitud();
    this.fetchMotivoEvaluacion();
    this.fetchTipoExpediente();
    this.fetchSexo();
    this.fetchEstadoCivil();
    this.fetchParentesco();
    this.fetchPuestos();
    this.fetchDependencias();
    this.fetchRamas();
    this.fetchAreas();
    this.fetchMunicipios();
    this.fetchDiagnostico();
    this.fetchNumerales();
    this.fetchEstatusEvaluacion();
    await this.fetchSemaforoResultado();
  },

  methods: {
    ...mapActions('derivaciones', ['fetchDerivacionesByArea']),
    ...mapActions('evaluadores', ['fetchEvaluadores']),
    ...mapActions('programacionEvaluacion', ['fetchProgramacionesEvaluaciones']),
    ...mapActions('tipoSolicitud', ['fetchTipoSolicitud']),
    ...mapActions('estatusProgramacion', ['fetchEstatusProgramacion']),
    ...mapActions('motivoEvaluacion', ['fetchMotivoEvaluacion']),
    ...mapActions('tipoExpediente', ['fetchTipoExpediente']),
    ...mapActions('solicitudes', ['fetchSolicitudes']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),
    ...mapActions('rama', ['fetchRamas']),
    ...mapActions('areas', ['fetchAreas']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('expediente', ['fetchExpedientes']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('parentesco', ['fetchParentesco']),
    ...mapActions('diagnostico', ['fetchDiagnostico']),
    ...mapActions('evaluadores', ['fetchEvaluadores']),
    ...mapActions('numerales', ['fetchNumerales']),
    ...mapActions('estatusEvaluacion', ['fetchEstatusEvaluacion']),
    ...mapActions('semaforoResultado', ['fetchSemaforoResultado']),
  },
};
</script>
